const rtlLanguages = ['ar', 'fa', 'he', 'ur'];

/**
 * Returns the language part of a locale (i.e. `en-US -> en`).
 *
 * @param locale Locale.
 */
type GetLanguage = (locale: string) => string;
export const getLanguage: GetLanguage = (locale) => {
  const [language] = locale.split('-');

  return language;
};

/**
 * Returns whether a locale is RTL.
 *
 * @param locale Locale.
 */
type IsRTL = (locale: string) => boolean;
export const isRTL: IsRTL = (locale) => rtlLanguages.includes(getLanguage(locale));

/**
 * Returns appropriate value to use in HTML dir attribute - ltr or rtl - based on language.
 * Passes through undefined as-is.
 *
 * @param locale Locale.
 */
type Direction = 'rtl' | 'ltr';
type GetDir = (locale: string | undefined) => Direction | undefined;
export const getDir: GetDir = (locale) => {
  if (!locale) {
    return undefined;
  }

  return isRTL(locale) ? 'rtl' : 'ltr';
};
